import { render, staticRenderFns } from "./erTextTag.vue?vue&type=template&id=22637ffe&"
import script from "./erTextTag.vue?vue&type=script&lang=js&"
export * from "./erTextTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports